module.exports = __webpack_public_path__ + "static/media/close_gray_icon.1581d0b2.png";